import { render, staticRenderFns } from "./PersonReport.vue?vue&type=template&id=a9fab3e6&scoped=true"
import script from "./PersonReport.vue?vue&type=script&lang=js"
export * from "./PersonReport.vue?vue&type=script&lang=js"
import style0 from "./PersonReport.vue?vue&type=style&index=0&id=a9fab3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fab3e6",
  null
  
)

export default component.exports